import type { ConsumerApiClient } from '../client';

export interface Promotion {
  id: string;
  name: string;
  code: string | null;
  type: 'discount_code' | 'storewide' | 'pelipoint_multiplier' | 'free_shipping';
  discountType: 'percentage' | 'fixed_amount' | null;
  discountValue: number | null;
  conditions: Record<string, any> | null;
  startDate: string;
  endDate: string | null;
  stackable: boolean;
}

export interface PromotionsApi {
  getActivePromotions(): Promise<Promotion[]>;
}

export function createPromotionsApi(client: ConsumerApiClient): PromotionsApi {
  return {
    getActivePromotions() {
      return client.get('/promotions');
    },
  };
}
